module.exports = __webpack_public_path__ + "img/appltCourse-img12.bd259461.png";